import React from 'react';

export default class ProtectedPage extends React.Component {
    render() {
        return <div className={this.props.className || ""}>
            {this.props.permitted ? this.props.children : <div className="page">
                <div className="no-results">
                    <i className="icon ion-eye-disabled"></i>
                    <span>You don't have permission to view this page.</span>
                </div>
            </div>}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/layoutComponents/ProtectedPage.jsx